import { GridFilterDto } from '../../../../../models/ts/grid-filter-dto.model';
import { FilterItemType } from '../../../../../models/ts/filter-item-type.model';

export class FilterModalData {
  constructor(public gridFilterDto: GridFilterDto, public cleared: boolean, public collectionsId: number, public widgetId:number, public filterItemType: FilterItemType) {}
}
